import { z } from 'zod';
import { makeFieldSchemaFromZod } from '../MultiEntityPickerRenderedString/utils';

export const entityQueryFilterExpressionSchema = z.record(
  z
    .string()
    .or(z.object({ exists: z.boolean().optional() }))
    .or(z.array(z.string())),
);

export const EntityPickerRenderedStringFieldSchema = makeFieldSchemaFromZod(
  z.string(),
  z.object({
    defaultKind: z
      .string()
      .optional()
      .describe(
        'The default entity kind. Options of this kind will not be prefixed.',
      ),
    allowArbitraryValues: z
      .boolean()
      .optional()
      .describe('Whether to allow arbitrary user input. Defaults to true'),
    defaultNamespace: z
      .union([z.string(), z.literal(false)])
      .optional()
      .describe(
        'The default namespace. Options with this namespace will not be prefixed.',
      ),
    catalogFilter: z
      .array(entityQueryFilterExpressionSchema)
      .or(entityQueryFilterExpressionSchema)
      .optional()
      .describe('List of key-value filter expression for entities'),
  }),
);

export type EntityPickerRenderedStringUiOptions =
  typeof EntityPickerRenderedStringFieldSchema.uiOptionsType;

export type EntityPickerRenderedStringProps =
  typeof EntityPickerRenderedStringFieldSchema.type;

export const EntityPickerRenderedStringSchema =
  EntityPickerRenderedStringFieldSchema.schema;

export type EntityPickerRenderedStringFilterQuery = z.TypeOf<
  typeof entityQueryFilterExpressionSchema
>;

export type EntityPickerRenderedStringFilterQueryValue =
  EntityPickerRenderedStringFilterQuery[keyof EntityPickerRenderedStringFilterQuery];
